import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './en';
import pt from './pt';
import es from './es';
import zh from './zh';
import fr from './fr';

// <html lang> follows the active language (public/index.html ships a fixed
// lang="en"). The detector can return a region (pt-BR, zh-TW): only the base
// language is used, and an unknown one falls back to en, like fallbackLng.
const HTML_LANG = { en: 'en', pt: 'pt-BR', es: 'es', zh: 'zh-CN', fr: 'fr' };

export function toHtmlLang(language) {
  const base = String(language || 'en').split('-')[0].toLowerCase();

  return HTML_LANG[base] || 'en';
}

function applyHtmlLang(language) {
  document.documentElement.lang = toHtmlLang(language);
}

// Registered before init so the first language resolution is applied too.
i18n.on('languageChanged', applyHtmlLang);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: en,
      },
      pt: {
        translations: pt,
      },
      es: {
        translations: es,
      },
      zh: {
        translations: zh,
      },
      fr: {
        translations: fr,
      },
    },
    fallbackLng: 'en',
    debug: true,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
